import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { FuelOrder } from 'src/app/models/fuel/fuel-order';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';

@Component({
    selector: 'app-fuel-history-detail',
    templateUrl: './fuel-history-detail.component.html',
    styleUrls: ['./fuel-history-detail.component.scss'],
    standalone: false
})
export class FuelHistoryDetailComponent implements OnInit {

  private urlPutHistoric: string = `${EndpointDictionary.HistoricalFuel.PUT_HISTORICAL_FUEL}`
  public formPutFO: UntypedFormGroup

  constructor(
    public dialogRef: MatDialogRef<FuelHistoryDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FuelOrder,
    private message: MessageService,
    private http: HttpService,
    private formBuilder: UntypedFormBuilder,

  ) {
    this.formPutFO = this.formBuilder.group(
      {
        id:this.data.id,
        totalPrice:"",
        billNumber:"",
        salesOrder:"",
        currentOdometer:0
    }
    )
  }

  ngOnInit(): void {
    this.message.openLoading('Cargando', 'Cargando información')
     this.initFild()
  }

  initFild(){
    this.message.closeLoading()
    this.formPutFO.get('totalPrice').setValue(this.data.totalPrice)
    this.formPutFO.get('billNumber').setValue(this.data.billNumber)
    this.formPutFO.get('salesOrder').setValue(this.data.salesOrder)
    this.formPutFO.get('currentOdometer').setValue(this.data.orderOdometer)
  }

  async updateHistory(form: FuelOrder){
    this.message.openLoading('Cargando', 'Actualizando Información')

    form.totalPrice = parseFloat(form.totalPrice.toString().replace(/[,.]/g, ''))
    let res: GenericResponse = await this.http.putDataBody(`${this.urlPutHistoric}`, form)
    if(res){
        this.message.closeLoading()
        this.dialogRef.close()
      }
  }

  errorMessage(){
    this.message.Error('Error', 'complete los campos')
  }

}
